import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../services/local-storage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-header-before-signup',
  templateUrl: './user-header-before-signup.component.html',
})
export class UserHeaderBeforeSignupComponent implements OnInit {

  constructor(private localstorage:LocalStorage,private router:Router) { }

  ngOnInit() {
  }
  redirectpage() {
     var token=this.localstorage.getStorage('token');
       var userType = this.localstorage.getStorage('usertype');
console.log(token);
console.log(userType);
     if(token && userType == 1) {
    this.router.navigate(['users/wall']); 
     }
     else {
       this.router.navigate(['']); 
     } 
  }

}



// WEBPACK FOOTER //
// ./src/app/common/user-header-before-signup.component.ts